import { ReactElement, useCallback, useState } from 'react'
import { SearchStore } from '../../../../store/search/SearchStore'
import { ProductLocationModel, ProductModel } from 'interfaces'
import { StoreCard } from './StoreCard'
import { Vehicle } from '../../../../store/models/Vehicles'
import { ISeller } from '../../../../services/MultiSellerServicesProvider'
import { MY_PLACE_SELLER } from 'common'

interface Props {
  vehicle: Vehicle
  seller: ISeller
  product: ProductModel
  activeLocation: ProductLocationModel
  searchStore: SearchStore
}

const StoreCards = (props: Props): ReactElement => {
  const { vehicle, product, activeLocation, searchStore, seller } = props

  const [locations, setLocations] = useState<ProductLocationModel[]>(
    product?.location || []
  )

  const onLocationsUpdate = useCallback(
    (updatedLocations: ProductLocationModel[]) => {
      setLocations([...updatedLocations])
    },
    []
  )

  const locationCards = locations.map((loc) => (
    <StoreCard
      key={loc.locationId}
      location={loc}
      selected={
        activeLocation &&
        Number(activeLocation.locationId) === Number(loc.locationId)
      }
      product={product}
      seller={seller ?? MY_PLACE_SELLER}
      vehicle={vehicle}
      searchStore={searchStore}
      onLocationsUpdate={onLocationsUpdate}
    />
  ))

  return <div>{locationCards}</div>
}

export default StoreCards
